import { Box, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useContext, useLayoutEffect, useState } from 'react';
import Logo from "../../assets/images/plany365.ico";
import { useQuery } from '@apollo/client';
import { GET_SUBSCRIPTION } from '../../graphql/mutations/subscription';
import { UserContext } from '../auth/auth-context';
import { Link as RouterLink } from 'react-router-dom';

const FloatingCompanyBrand = (props) => {
    const location = useLocation();
    // Get the first segment of the URL path as the business URL parameter.
    const businessUrlParam = location.pathname.split("/").filter(Boolean)[0];
    const navigate = useNavigate();
    const [subscription, setSubscription] = useState(null);

    // Fetch the subscription data using the business URL parameter.
    const { loading: loadingSubscription, error: errorSubscription, data: dataSubscription } = useQuery(GET_SUBSCRIPTION, {
        variables: { businessUrl: businessUrlParam },
    });

    const userContext = useContext(UserContext);
    const providerUser = userContext.providerUser;

    // Update the subscription state when the data is available.
    useLayoutEffect(() => {
        if (dataSubscription && dataSubscription.getSubscription) {
            setSubscription({
                ...dataSubscription.getSubscription,
                businessBasic: dataSubscription.getSubscription
            });
        }
    }, [dataSubscription]);

    if (loadingSubscription) {
        return <div>Loading...</div>;
    }

    // Convert the planId from the subscription to a number.
    const planId = (subscription?.planId && Number(subscription?.planId)) || 1;

    // If the subscription plan is 1, use the existing behavior.
    if (planId === 1) {
        return (
            <Box
                sx={{
                    position: "fixed", // Fixed positioning ensures it stays in place on scroll.
                    top: '0.1px',      // Stick to the top of the window.
                    left: '50%',       // Center horizontally.
                    transform: 'translateX(-50%)',  // Perfect centering.
                    borderRadius: "8px",
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "#f5f5f5",
                    },
                }}
                onClick={() =>
                    providerUser.defaultBusinessId
                        ? navigate('/biz/bookingtypes')
                        : navigate('/')
                }
            >
                <img
                    src={Logo}
                    alt="Company Logo"
                    style={{ width: '50px', height: '50px' }}  // Set image dimensions.
                />
            </Box>
    );
    }

    // If the subscription plan is above 1, redirect to the business page.
    else if (planId > 1) {
        return (
            <Box
                component={RouterLink}
                to={`/${businessUrlParam}`}
                sx={{
                    position: "fixed",
                    top: "0.1px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    borderRadius: "8px",
                    cursor: "pointer",
                    textDecoration: "none", // remove default link styling
                    "&:hover": {
                        backgroundColor: "#f5f5f5",
                    },
                }}
            >
                <Typography variant="h6" component="span">
                    {subscription?.businessName}
                </Typography>
            </Box>
        );
    } else {
        return null;
    }
};

export default FloatingCompanyBrand;
